export const grade = [
    'SIXIEME',
    'CINQUIEME',
    'QUATRIEME',
    'TROISIEME',
    'SECONDE',
    'PREMIERE',
    'TERMINALE',
];
export const GradeEnum = {
    SIXIEME: 'Sixième',
    CINQUIEME: 'Cinquième',
    QUATRIEME: 'Quatrième',
    TROISIEME: 'Troisième',
    SECONDE: 'Seconde',
    PREMIERE: 'Première',
    TERMINALE: 'Terminale',
};
